<script setup lang="ts">
import { type TextVariants } from '@/components/lib/base/GwText/gwTextVariants'

export interface TextProps {
  variant: TextVariants
  // eslint-disable-next-line no-undef
  tag?: keyof HTMLElementTagNameMap
  id?: string | number
}

withDefaults(defineProps<TextProps>(), {
  tag: 'span',
})
</script>

<template>
  <component
    :is="tag"
    :id
    :class="variant"
  >
    <slot></slot>
  </component>
</template>
